export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '안전한 차량',
      description: '정기적인 점검과 꾸준한 세차 관리로 항상 최상의 상태를 유지합니다.'
    },
    {
      icon: 'ri-time-line',
      title: '빠른 예약',
      description: '온라인으로 간편하게 예약하고 바로 이용하세요'
    },
    {
      icon: 'ri-map-pin-line',
      title: '무료 배달',
      description: '대전 전역 및 세종,공주등 인근지역 무료 배달 서비스를 제공합니다'
    },
    {
      icon: 'ri-customer-service-line',
      title: '친절한 상담',
      description: '전문 상담원이 24시간 고객님을 도와드립니다'
    },
    {
      icon: 'ri-wallet-line',
      title: '합리적 가격',
      description: '투명한 가격 정책으로 추가 비용 걱정 없습니다'
    },
    {
      icon: 'ri-star-line',
      title: '높은 만족도',
      description: '수많은 고객들의 긍정적인 후기가 증명합니다'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            왜 대전렌트카를 선택해야 할까요?
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            고객 만족을 최우선으로 생각하는 대전렌트카의 특별한 서비스를 경험하세요
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br from-primary to-secondary rounded-full mb-4 md:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-white text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3">
                {feature.title}
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
